<template>
  <div id="app">
    <component :is="entryComponent" />
  </div>
</template>

<script>
import Entry from '@/views/Entry/index.vue'
import MobileEntry from '@/views/MobileEntry/index.vue'
export default {
  name: 'App',
  components: {
    Entry,
    MobileEntry
  },
  data() {
    return {
      language: localStorage.getItem('Language')
    }
  },
  computed: {
    entryComponent() {
      return this.isMobile() ? 'MobileEntry' : 'Entry'
    }
  },
  mounted() {
    if (!!this.language) {
      console.log(localStorage.getItem('Language'))
      if (this.language === 'en-US') {
        document.title = 'Guangyang Egg Industry'
      } else {
        document.title = '光阳蛋业'
      }
    }
  },
  methods: {
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
      return mobileRegex.test(userAgent)
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>
